import {
  takeLatest, put, cancel, delay,
} from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';

import * as request from 'lib/provider/request';
import type { RSVPParam } from 'lib/provider/requests/invitation';

import { select, call } from 'store/utils/saga/effects';
import * as cardStore from 'store/nodes/card';

import * as toastActions from '../../toast/actions';

import * as actions from '../actions';
import * as selectors from '../selectors';

export const config = {
  action: actions.sendNote.type,
  method: takeLatest,
};

export function* func(action: SagaReturnType<typeof actions.sendNote>) {
  const { payload } = action;

  const uuid = yield* select(cardStore.selectors.getUuid);
  const isShareableLink = yield* select(cardStore.selectors.isShareableLink);
  const rsvp = yield* select(selectors.getRSVP);

  if (!uuid || !rsvp) {
    yield put(actions.requestDone('note'));
    yield cancel(); return;
  }

  const data: RSVPParam = {
    id: rsvp.id,
    eventId: rsvp.eventId,
    note: payload?.note ?? rsvp.note,
  };

  if (isShareableLink) {
    data.name = payload?.name;
  }

  const response = yield* call(() => request.invitation.update(uuid, data));
  if (response.error || !response.data) {
    yield put(actions.requestDone('note'));
    yield cancel(); return;
  }

  yield put(actions.setRSVP(response.data, 'update'));
  yield put(actions.requestDone('note'));

  yield delay(10);

  yield put(actions.close());
  yield put(toastActions.showToast('RSVP updated', 2000));
}
